import { Route, Routes } from "react-router-dom";
import CreateNewWorkspaces from "./CreateNewWorkspaces/CreateNewWorkspaces";
import Home from "./Home/Home";
import "./Workspaces.css";
import WorkspaceDetails from "./WorkspaceDetails/WorkspaceDetails";
import CreateWorkspaceFolder from "./WorkspaceDetails/WorkspaceDetailsAction/CreateWorkspaceFolder/CreateWorkspaceFolder";
import RunQuickAction from "./RunQuickAction/RunQuickAction";
import ParentRunQuickAction from "./RunQuickAction/ParentRunQuickAction";
import RunQuickActionHistory from "./RunQuickActionHistory/RunQuickActionHistory";
import EditWorkspaceFolder from "./WorkspaceDetails/WorkspaceDetailsAction/CreateWorkspaceFolder/EditWorkspaceFolder";
const Workspaces = () => {
  return (
    <div className="workspace-main ">
      <Routes>
        <Route exact={true} path={"/"} element={<Home />} />
        <Route
          exact={true}
          path={"/newWorkspaces"}
          element={<CreateNewWorkspaces />}
        />
        <Route
          exact={true}
          path={"/newWorkspaces/:id"}
          element={<CreateNewWorkspaces />}
        />
        <Route
          exact={true}
          path={"/createFolder"}
          element={<CreateWorkspaceFolder />}
        />
        <Route
          exact={true}
          path={"/createFolder/:id"}
          element={<EditWorkspaceFolder />}
        />
        <Route
          exact={true}
          path={"/:name/:id/details"}
          element={<WorkspaceDetails />}
        />
        <Route
          exact={true}
          path={"/runQuickAction/:id"}
          element={<ParentRunQuickAction />}
        />

        <Route
          exact={true}
          path={"/runQuickActionHistory/:id/:Qaid"}
          element={<RunQuickActionHistory />}
        />
        {/* <Route exact={true} path={"/details"} element={<WorkspaceDetails />} /> */}
      </Routes>
    </div>
  );
};

export default Workspaces;
